import { motion } from "framer-motion";
import { Reveal, SectionTag, SectionTitle } from "./shared";
import { CONNECTIVITY } from "../data/site";

const CENTER = { x: 480, y: 300 };

export function Connectivity() {
  return (
    <section className="relative py-28 lg:py-40 bg-[#0D0D0D]" data-testid="connectivity-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Connectivity</SectionTag>
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-14">
          <SectionTitle>Connected to <span className="text-gold-gradient italic">Everything That Matters.</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="text-sm text-[#71717A] leading-relaxed max-w-md lg:ml-auto">
              Routes are indicative. Journey times quoted in our Travel Time Estimator are indicative
              ranges from public reports - ask an advisor for a present-day drive assessment.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="border border-[#D4AF37]/15 bg-[#0A0A0A] rounded-[2px] overflow-hidden" data-testid="connectivity-map">
            <svg viewBox="0 0 960 620" className="w-full h-auto" role="img" aria-label="Connectivity map">
              <defs>
                <filter id="glow2" x="-50%" y="-50%" width="200%" height="200%">
                  <feGaussianBlur stdDeviation="3.5" result="b" />
                  <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
                </filter>
              </defs>
              {Array.from({ length: 11 }).map((_, i) => (
                <line key={`v${i}`} x1={i * 96} y1="0" x2={i * 96} y2="620" stroke="#1a1a1a" strokeWidth="1" />
              ))}
              {Array.from({ length: 7 }).map((_, i) => (
                <line key={`h${i}`} x1="0" y1={i * 96} x2="960" y2={i * 96} stroke="#1a1a1a" strokeWidth="1" />
              ))}

              {CONNECTIVITY.map((d, i) => (
                <g key={d.label}>
                  <motion.path
                    d={`M ${CENTER.x} ${CENTER.y} L ${d.x} ${d.y}`}
                    fill="none" stroke="#D4AF37" strokeWidth="1.1" strokeOpacity="0.55"
                    className="route-anim" filter="url(#glow2)"
                    initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
                    transition={{ delay: 0.3 + i * 0.1 }}
                  />
                  <circle cx={d.x} cy={d.y} r="4" fill="#0A0A0A" stroke="#D4AF37" strokeWidth="1.3" />
                  <text x={d.x} y={d.y - 12} textAnchor="middle" fill="#A1A1AA" fontSize="10.5" letterSpacing="1.5" style={{ fontFamily: "Manrope" }}>
                    {d.label.toUpperCase()}
                  </text>
                  <text x={d.x} y={d.y + 20} textAnchor="middle" fill="#52525b" fontSize="9" style={{ fontFamily: "Manrope" }}>
                    {d.note}
                  </text>
                </g>
              ))}

              <motion.circle
                cx={CENTER.x} cy={CENTER.y} r="8" fill="#D4AF37" filter="url(#glow2)"
                initial={{ r: 8 }} animate={{ r: [8, 11, 8] }} transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              />
              <text x={CENTER.x} y={CENTER.y + 32} textAnchor="middle" fill="#F3E5AB" fontSize="13" letterSpacing="3" style={{ fontFamily: "Manrope" }}>
                GAUR YAMUNA CITY
              </text>
            </svg>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
